import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CellComponent, CellContext, GridData } from '@grid/models';

@Component({
  selector: 'app-mandatory-date',
  templateUrl: './mandatory-date.component.html',
  styleUrls: ['./mandatory-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MandatoryDateComponent implements CellComponent<GridData> {
  @Input({ required: true }) context!: CellContext<GridData>;
}
